module.exports = __webpack_public_path__ + "img/title.ecfe66ea.png";